import { Fragment } from "react/jsx-runtime";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../../AbstractElements";
import { FormControlsTitle, FormValidationTitle } from "../../../../../Constants/Constants";
import BrowserDefaults from "./BrowserDefaults";
import TooltipFormValidation from "./TooltipFormValidation/TooltipFormValidation";
import ValidationForm from "./ValidationForm/ValidationForm";

const FormValidationContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={FormValidationTitle} parent={FormControlsTitle} />
      <Container fluid>
        <Row>
          <TooltipFormValidation />
          <BrowserDefaults />
          <ValidationForm />
        </Row>
      </Container>
    </Fragment>
  );
};

export default FormValidationContainer;
